/**
 * Shown while a lazily-loaded route chunk is downloading.
 *
 * Deliberately minimal: it must live in the main bundle, so anything it pulls
 * in is weight added to every first paint.
 */
export const RouteFallback = () => (
    <div
        className="flex min-h-screen items-center justify-center bg-white"
        role="status"
        aria-live="polite"
    >
        <div className="flex flex-col items-center gap-4">
            <div
                className="h-10 w-10 animate-spin rounded-full border-4 border-brand-blue/20 border-t-brand-blue"
                aria-hidden="true"
            />
            <span className="sr-only">Loading page</span>
        </div>
    </div>
);
